<template>
  <b-card
    v-if="items"
    no-body
  >
    <!-- chart -->
    <b-row class="p-1">
      <b-col lg="6">
        <h3>{{ $t('Number of doctoral students by direction') }}</h3>
      </b-col>
      <b-col
        lg="6"
        class="mt-0"
      >
        <b-form-group
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="my-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              :placeholder="$t('Search')"
            />

            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
              >
                {{ $t("Clear") }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      :items="items"
      :filter="filter"
      :filter-included-fields="filterOn"
      show-empty
      responsive
      :fields="fields"
      class="mb-0"
      :per-page="perPage"
      :current-page="currentPage"
      @filtered="onFiltered"
    >
      <template #head()="data">
        {{ getHead(data) }}
      </template>

      <template #cell(index)="data">
        {{ (currentPage - 1) * perPage + data.index + 1 }}
      </template>

      <template #cell(name)="data">
        {{ $langName(data.value) }}
      </template>

    </b-table>
    <div class="mb-1 mr-1">
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-end justify-content-end justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>
      </b-row>
    </div>
  </b-card>
</template>
<script>
import {
  BCard, BCardHeader, BCardTitle, BTable, BPagination, BRow, BCol, BInputGroup, BFormInput, BFormGroup, BInputGroupAppend, BButton,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  name: 'OrgCountByDirection',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BTable,
    BPagination,
    BRow,
    BCol,
    BInputGroup,
    BFormInput,
    BFormGroup,
    BInputGroupAppend,
    BButton,
  },
  props: {
    items: {
      type: Array,
      default: [],
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      filter: null,
      filterOn: [],
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.total = filteredItems.length
      this.currentPage = 1
    },
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](Number(id))
    },
    getHead(head) {
      const col = head.column
      if (Number(col) >= 100 && Number(col) <= 700) {
        return this.$langName(this.getDcType(col).name)
      }
      return this.$t(head.label)
    },
  },
  setup() {
    const fields = [
      { key: 'index', label: '#' },
      { key: 'name', label: 'Direction', thClass: 'h6' },
      { key: 'code', label: 'Code', thClass: 'h6' },
      { key: '100', label: '', thClass: 'h6' },
      { key: '200', thClass: 'h6' },
      { key: '300', thClass: 'h6' },
      { key: '400', thClass: 'h6' },
      { key: '500', thClass: 'h6' },
      { key: '600', thClass: 'h6' },
      { key: '700', thClass: 'h6' },
      { key: 'total', label: 'Total', thClass: 'h6' },
    ]
    const perPage = ref(8)
    const currentPage = ref(1)
    const MODULE_NAME = 'statistic'
    return {
      MODULE_NAME,
      fields,
      perPage,
      currentPage,
    }
  },
}
</script>

<style scoped>

</style>
